import { Helmet } from "react-helmet-async";
import { BRAND, ORG } from "@/lib/constants";

/**
 * Per-page SEO + Open Graph + Twitter Card overrides.
 * Sitewide defaults live in /app/frontend/public/index.html.
 * Anything passed here overrides the document defaults for that page.
 *
 * Usage:
 *   <PageMeta
 *     title="2027 NCR Spring Conference & Phoenix 60th Anniversary"
 *     description="..."
 *     path="/2027"
 *     image="https://..."   // optional — falls back to Phoenix badge
 *   />
 */
export default function PageMeta({
  title,
  description,
  path = "/",
  image = BRAND.logoUrl,
  imageAlt = BRAND.logoAlt,
}) {
  const siteName = ORG.name;
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const url = `${ORG.websiteUrl}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />

      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={imageAlt} />
    </Helmet>
  );
}
